export default __webpack_public_path__ + "scene5_3_bgc8d4e0.png";